import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'
import TaxExtensionProgressionActions from '../TaxExtensionProgressionActions'

interface PreparationCompletedProgressionProps {
  vm: JobProgressionViewModel
  canCompleteJob?: boolean
}

export default observer(function CompleteJobProgressionActions({
  vm,
}: PreparationCompletedProgressionProps) {
  return (
    <>
      {!vm.isAnyExtensionFlowAvailable && (
        <CardContent compactBottomPadding={vm.isAnyExtensionFlowAvailable}>
          <Button
            type="primary"
            size="wide-slim"
            onClick={() => vm.closeJob()}
            dataTest="job-progression-complete-job-button"
          >
            Complete Job
          </Button>
        </CardContent>
      )}

      {vm.isAnyExtensionFlowAvailable && (
        <TaxExtensionProgressionActions vm={vm} isSecondary />
      )}
    </>
  )
})
